import type { SchedulePrefill } from "@/api/schedule/models";
import { Callout } from "@/components/common";
import { InputRow, InputValue } from "@/components/common/inputs";
import type { FormControl } from "@/interfaces/form";

interface Props {
  control: FormControl;
  prefill: SchedulePrefill | null;
  isLoading: boolean;
  error: string | null;
  isMinor: boolean;
}

export function PhotoRenewalTalentSection({ control, prefill, isLoading, error, isMinor }: Readonly<Props>) {
  return (
    <section>
      <h2 className="mb-4 text-base font-medium text-title">Dados do talento</h2>
      <InputValue
        control={control}
        field="talentCode"
        label="Codigo do talento"
        placeholder="Ex: F00000SP"
        className="mb-4"
      />
      {isLoading && <Callout>Buscando dados do talento...</Callout>}
      {error && <Callout>{error}</Callout>}

      <InputRow className="mb-4">
        <InputValue
          control={control}
          field="fullName"
          label="Nome completo"
          value={prefill?.fullName ?? ""}
          placeholder="Ex: Maria Mcfinney"
          disabled
        />
        <InputValue
          control={control}
          field="birthday"
          label="Data de nascimento"
          value={prefill ? new Date(prefill.birthday).toLocaleDateString("pt-BR") : ""}
          placeholder="Ex: 12/12/1997"
          disabled
        />
      </InputRow>

      {!isMinor && (
        <>
          <InputRow>
            <InputValue
              control={control}
              field="talentEmail"
              label="Email"
              value={prefill?.email ?? ""}
              placeholder="Ex: email@exemplo.com.br"
              disabled
            />
            <InputValue
              control={control}
              field="talentPhone"
              label="Telefone 1 (WhatsApp)"
              value={prefill?.phone ?? ""}
              placeholder="Ex: (00) 00000-0000"
              disabled
            />
          </InputRow>
          <InputValue
            control={control}
            field="talentSecondaryPhone"
            label="Telefone 2"
            value={prefill?.secondaryPhone ?? ""}
            placeholder="Ex: (00) 00000-0000"
            disabled
            className="mt-4"
          />
        </>
      )}
    </section>
  );
}
